<script setup lang="ts">
import { useTheme } from '@/features/theme/composables/useTheme';
import { SunIcon, MoonIcon, MonitorIcon } from 'lucide-vue-next';
import { lazyStrings } from '@/strings';

const { themeMode, setTheme } = useTheme();


defineExpose({
  ...((__BUILD_MODE_IS_TEST__ && {
    TEST_ONLY: {
      // Export internal state and logic used only for testing here. Do not reference these in production logic.
    },
  }) || {}),
});

import "virtual:naidan-tailwind-css-module/0fb53428ede5846e98b9c55b6592e1248fc58f5c38469a0311222fb3c16029a3.js";
import "virtual:naidan-tailwind-css-module/38ddc67182078de9cb932ed083d7a1455eaffe85410676015e4a7f0e622ff047.js";
</script>

<template>
  <div tw-class="relative flex items-center bg-gray-200 dark:bg-black p-0.5 rounded-xl border border-gray-300 dark:border-gray-800 shadow-[inset_0_2px_4px_rgba(0,0,0,0.15)] w-full">
    <!-- Sliding Indicator (Solid Convex Plate Look) -->
    <div
      data-testid="theme-indicator"
      tw-class="absolute top-0.5 bottom-0.5 left-0.5 w-[calc(33.333%-0.666px)] bg-white dark:bg-gray-700 rounded-lg shadow-[0_2px_0_rgba(0,0,0,0.05),0_4px_6px_rgba(0,0,0,0.15)] dark:shadow-[0_4px_10px_rgba(0,0,0,0.5)] border border-gray-200 dark:border-gray-600 transition-transform duration-300 ease-in-out"
      :style="{
        transform: themeMode === 'light' ? 'translateX(0)' :
          themeMode === 'dark' ? 'translateX(100%)' :
          'translateX(200%)'
      }"
    >
    </div>

    <button
      @click="setTheme({ mode: 'light' })"
      :tw-class="['relative z-10 flex-1 flex justify-center py-1.5 rounded-lg transition-colors duration-300', themeMode === 'light' ? 'text-blue-600 dark:text-yellow-400' : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300']"
      :title="lazyStrings.ThemeToggle__light_mode()"
    >
      <SunIcon tw-class="w-3.5 h-3.5" />
    </button>
    <button
      @click="setTheme({ mode: 'dark' })"
      :tw-class="['relative z-10 flex-1 flex justify-center py-1.5 rounded-lg transition-colors duration-300', themeMode === 'dark' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300']"
      :title="lazyStrings.ThemeToggle__dark_mode()"
    >
      <MoonIcon tw-class="w-3.5 h-3.5" />
    </button>
    <button
      @click="setTheme({ mode: 'system' })"
      :tw-class="['relative z-10 flex-1 flex justify-center py-1.5 rounded-lg transition-colors duration-300', themeMode === 'system' ? 'text-blue-600 dark:text-green-400' : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300']"
      :title="lazyStrings.ThemeToggle__system_mode()"
    >
      <MonitorIcon tw-class="w-3.5 h-3.5" />
    </button>
  </div>
</template>
